module.exports = __webpack_public_path__ + "img/adulto38.1ca5847e.jpg";